import { safeGet } from '../../core/util/object';
import { bookingTimeSelected } from '../../actions/newBooking';

export const prepopulateAppointmentDate = context => {
  const safeAppointmentDate = safeGet(context.query)('appointment_date');

  if (safeAppointmentDate) {
    const appointmentDate = parseInt(safeAppointmentDate, 10);
    if (!isNaN(appointmentDate)) {
      context.store.dispatch(bookingTimeSelected(appointmentDate));
    }
  }
};
